import { injectGlobal } from 'styled-components';

import { Config } from './service';

const colors = Config.styles.colors;

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html,
  body {
    width: 100%;
    min-width: 300px;
    font-weight: 400;
    color: #656b79;
    font-size: 16px;
    height: auto;
    min-height: max(100vh, 100%);
  }

  /* Unified Scrollbar Styles */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(177, 183, 196, 0.25);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #BBC1CB;
    border-radius: 4px;
    transition: background-color 0.2s ease;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9CA3AF;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  /* Firefox Scrollbar Styles */
  * {
    scrollbar-width: thin;
    scrollbar-color: #BBC1CB rgba(177, 183, 196, 0.25);
  }

  /* Ant Design Calendar Time Picker Exception */
  .ant-calendar-time-picker-select::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  body {
    font-family: Open Sans, 'Segoe UI', 'Droid Sans', Tahoma, Arial, sans-serif;
  }

  body.fontLoaded {
    font-family: Open Sans, 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    position: relative;
    height: 100%;
    background-color: #f8f8f8;
    min-height: max(100vh, 100%);
    min-width: 100%;
  }

  p,
  label {
    font-family: Open Sans, Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  span {
    font-family: Open Sans, Georgia, Times, 'Times New Roman', serif;
  }

  .nav-menu-link {
    color: #656b79;
    font-weight: 400;
  }

  .nav-menu-link-active {
    color: #fff!important;
    background-color: #00b785!important;
  }

  .nav-menu-link-active:focus {
    color: #fff;
    background-color: #00b785!important;
  }

  .nav-menu-link-active:after {
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 9px 9px 9px 0;
    border-color: transparent #f3f4f6 transparent transparent;
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -9px;
    right: 0px;
  }

  .galary-modal-wrap.ant-modal-wrap {
    text-align: center;
  }

  .galary-modal.ant-modal {
    display: inline-block;
    // width: inherit !important;
    width: 90%!important;
  }

  .closed a.nav-menu-link:not(.nav-menu-link-active):hover {
    color: #656b79;
    background-color: rgba(255, 255, 255, 0.4)!Important;
  }

  .active .nav-menu-cont > a.nav-menu-link {
    color: #fff!important;
    background-color: #00b785!important;
  }

  .closed .nav-menu-cont .nav-menu-link:not([href]):not([tabindex]) {
    color: #656b79;
    position: 'relative';
    z-index: 2;
    background-color: #e6e9ee;
  }

  .closed .nav-menu-cont .nav-menu-link:not([href]):not([tabindex]):hover {
    color: #656b79;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .nav-menu-cont > ul .nav-menu-link-active {
    color: #3d414a!important;
    font-weight: 600;
    background-color: #d9dbe0!Important;
  }

  .nav-menu-cont a {
    color: #656b79;
  }

  .nav-menu-cont > ul .nav-menu-link-active:after {
    display: none;
  }

  .open .nav-menu-cont > a.nav-menu-link:before {
    content: "\\f107";
    opacity: .5;
    /*display: block;*/
  }

  .nav-menu-cont > a.nav-menu-link:before {
    font-family: FontAwesome;
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    text-align: right;
    padding-right: 0px;
    display: inline-block;
    float: right;
    -webkit-font-smoothing: antialiased;
  }

  .closed .nav-menu-cont > a.nav-menu-link:before {
    content: '\\f105';
    opacity: .5;
    /*display: block;*/
  }

  .short-menu a.nav-menu-link span, .short-menu a.nav-menu-link:before {
    display: none;
  }

  .short-menu a.nav-menu-link:hover {
    width: 256px;
  }

  .short-menu a.nav-menu-link:hover span {
    display: inline-block;
  }

  .short-menu .nav-menu-cont > ul {
    position: absolute!Important;
    left: 40px;
    width: 190px;
  }

  .short-menu .nav-menu-cont > ul a.nav-menu-link:hover {
    width: 190px;
  }

  .short-menu a.nav-menu-link:hover ul {
    height: auto!Important;
    z-index: 1!Important;
  }

  .short-menu .nav-menu-cont > ul span {
    display: inline-block;
  }

  .short-menu .nav-menu-cont:hover span {
    display: inline-block;
  }

  .short-menu .nav-menu-cont:hover > a {
    width: 256px;
    color: #656b79;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .short-menu .nav-menu-cont > ul {
    display: none;
  }

  .short-menu .nav-menu-cont:hover > ul {
    display: block;
  }

  .short-menu .active .nav-menu-cont > a:after {
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 9px 9px 9px 0;
    border-color: transparent #f3f4f6 transparent transparent;
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -9px;
    right: 0px;
  }

  .short-menu .ant-menu {
    padding: 0 2px!important;
  }

  .btn-info {
    background-color: #4697ce!Important;
    border-color: #4697ce!Important;
  }

  .btn-info:hover {
    background-color: #2f7db2!Important;
    border-color: #2d77aa!Important;
  }

  .btn-default {
    color: #656b79;
    background-color: #e9ecf0;
    border-color: #e9ecf0;
  }

  .btn-default:hover, .btn-default:focus, .btn-default:active, .btn-default.active {
    color: #656b79;
    background-color: #cbd2db;
    border-color: #c5cdd7;
  }

  .ag-body .ag-body-container .ag-row.my-error-effect {
    background: #FC9191!Important
  }

  .grid-table {
    .ag-header {
      border-bottom: 2px solid #e9ecf0!Important;
      .ag-header-cell-label {
        text-align: left;
        font-weight: bold;
        font-size: 13px;
        .ag-header-icon {
          margin-top: 0;
          margin-left: 5px;
        }
      }
    }
    .ag-root {
      border: none!Important;
    }
    .ag-header-cell-menu-button {
     padding-top: 10px!Important;
    }
    .ag-header-cell-label {
      padding-top: 10px!Important;
      padding-left: 10px!Important;
    }
    div.ag-cell-no-focus {
      border-right: none!Important;
      border-left: none!Important;
      border-bottom: 1px solid #e9ecf0!Important;
      color: #656b79;
      font-size: 13px;
      cursor: text;
      display: flex;
      align-items: center;
      padding-left: 10px;
    }
    .ag-header-container {
       color: #656b79;
       border: none;
       background-color: #fff;

       div.ag-header-cell {
          border: none;
       }
    }
    .ag-row {
      &:hover {
        background-color: #e9ecf0;
      }
    }
    .ag-floating-bottom {
      background: #DEDEDE;
      .ag-row {
        background-color: #DEDEDE;
      }
    }
    .ag-paging-panel {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .ag-paging-page-summary-panel {
      .ag-paging-button {
        background-color: #fff;
        border: 1px solid #e1e3e8;
        color: #4697ce;
        min-width: 42px;
        height: 36px;
        margin: 0;
        padding: 5px;
        margin-right: -5px;
        cursor: pointer;

        &[ref='btPrevious'] {
          margin-right: 5px;
        }
        &:hover {
          background-color: #fbfbfb;
          border-color: #ddd;
        }
        &:disabled {
          background: #e0e0e0;
          color: #999;
          cursor: no-drop;
        }
      }
    }
  }
  .ag-header-align-right {
    align-items: end !important;
  }
  #nprogress {
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
  }

  #nprogress .bar {
      background: #108ee9;
      position: fixed;
      z-index: 1024;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 2px
  }

  #nprogress .peg {
      display: block;
      position: absolute;
      right: 0;
      width: 100px;
      height: 100%;
      box-shadow: 0 0 10px #108ee9,0 0 5px #108ee9;
      opacity: 1;
      -webkit-transform: rotate(3deg) translateY(-4px);
      -ms-transform: rotate(3deg) translateY(-4px);
      transform: rotate(3deg) translateY(-4px)
  }

  #nprogress .spinner {
      display: none;
  }

  #nprogress .spinner-icon {
      width: 18px;
      height: 18px;
      box-sizing: border-box;
      border: 2px solid transparent;
      border-top-color: #108ee9;
      border-left-color: #108ee9;
      border-radius: 50%;
      -webkit-animation: YOelr .4s linear infinite;
      animation: YOelr .4s linear infinite
  }

  .nprogress-custom-parent {
      overflow: hidden;
      position: relative
  }

  .nprogress-custom-parent #nprogress .bar,.nprogress-custom-parent #nprogress .spinner {
      position: absolute
  }

  .ant-group-custom {
    .has-success.has-feedback:after {
      right: 30px;
    }
  }

  .ant-select-selection__rendered {
    ul {
      margin-bottom: 0;
    }
  }

  .ant-select-dropdown-auto-width {
    width: auto !important;
  }

  .logout-panel {
    .ant-modal-footer {
      display: flex;
    }
  }

  .ant-menu-dark {
    background: #1f2937!important;
  }

  .mobileMenuPopover.dark .ant-popover-inner-content {
    background: #1F2937;
  }

  .mobileMenuPopover.dark .ant-popover-arrow {
    border-color: #1F2937;
  }

  .mobileMenuPopover .ant-menu {
    width: 288px;
    padding: 0 0 16px 0!important;
  }

    .ant-popover {
    cursor: pointer;

    .ant-popover-inner-content {
      padding-left: 0!Important;
      padding-right: 0!Important;
    }

    .menu-button {
      width: 100%;
      text-decoration: none;
      padding-left: 16px;
      padding-right: 16px;
      min-width: 280px;
      span {
        transition: all .3s ease-out;
        color: ${colors.greyDark};
        &:hover {
          color: ${colors.blue};
          opacity: 0.6;
        }
      }

      &:hover {
        color: ${colors.blue};
        transition: all .3s ease-out;
        text-decoration: none;
        //background-color: #f8f8f8;
      }
    }

    .menu-text {
      line-height: 35px;
      color: ${colors.greyDark};
      padding-left: 16px;
      padding-right: 16px;
      min-width: 280px;
    }

    .menu-link {
      transition: all .3s ease-out;
      color: ${colors.greyDark};
      width: 100%;
      text-decoration: none;
      line-height: 20px;
      padding-left: 16px;
      padding-right: 16px;
      min-width: 280px;
      a {
        width: 100%;
        span {
          width: 100%;
        }
        &:hover {
          color: ${colors.blue};
          transition: all .3s ease-out;
          text-decoration: none;
        }
      }

      &:hover {
        color: ${colors.blue};
        opacity: 0.6;
      }
    }
  }

  .ant-modal-confirm-body {
    .ant-modal-confirm-content {
      margin-top: 0;
    }
  }

  .ant-modal-content {
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  }

  .ant-modal.ant-confirm.tran-dialog {
    .ant-modal-content {
      border: 2px solid #64bd63;
      border-radius: 6px;
      .ant-modal-body {
        padding: 0;
        .ant-confirm-title {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          display: block;
          padding: 40px;
          text-align: center;
          color: white;
          font-size: 24px;
          background-color: #64bd63;
        }
        .ant-confirm-content{
           margin-left: 0;
           text-align: center;
          .i-complete {
            margin-top: -50px;
            font-size: 64px;
            line-height: 64px;
            font-weight: bold;
            color: #64bd63;
            background-color: #fff;
            padding: 8px;
            border-radius: 50%;
            display: inline-block;
          }
          .ant-card {
            margin: 20px auto;
            display: inline-block;
            font-size: 28px;
            color: #f0934e;
            border-color: #f0934e;
            .ant-card-body {
              padding: 10px 30px;
            }
          }
        }
        .ant-confirm-btns {
          display: block;
          float: none;
          text-align: center;
          .ant-btn {
            background-color: #64bd63;
            border-color: #64bd63;
            margin: 2% 0;
            width: 96%;
            font-size: 28px;
            height: auto;
            padding: 10px;
          }
        }
      }
    }
  }
  .ant-modal.ant-confirm.tran-dialog.error {
    .ant-modal-content {
      border: 2px solid #f04134;
      .ant-confirm-title {
        background-color: #f04134;
      }
      .ant-btn {
        background-color: #f04134 !important;
        border-color: #f04134 !important;
      }
      .i-complete {
        color: #f04134 !important;
      }
      .ant-alert {
        margin: 30px;
        text-align: left;
      }
    }
  }
  .ant-tabs-tab-active {
    border-bottom: 2px solid transparent !important;
  }
  .ant-calendar-range {
    @media (max-width: 700px) {
      width: 100%;
    }
  }

  .ant-calendar-range-right .ant-calendar-date-input-wrap {
    @media (max-width: 700px) {
      margin-left: -100px;
    }
  }

  form label[for='private'] {
    display: inline-block!Important;
  }

  @media (min-width: 641px) {
    form input::-webkit-input-placeholder {
      color: transparent !important;
    }
    form input::-moz-placeholder {
      color: transparent !important;
    }
    form textarea::placeholder {
      color: transparent !important;
    }

  }

  input.show-placeholder::-webkit-input-placeholder {
    color: #cdd5d5 !important;
  }

  input.show-placeholder::-moz-placeholder {
    color: #cdd5d5 !important;
  }

  .show-placeholders input::-webkit-input-placeholder {
    color: #999 !important;
  }

  .show-placeholders input::-moz-placeholder {
    color: #999 !important;
  }

  .show-label label {
    display: block;
    float: left;
  }

  .ant-calendar-range-middle {
    @media (max-width: 700px) {
      margin-left: -113px;
    }
  }
  .btn {
    border: none;
  }
  @media (min-width: 1200px) {
    .ant-form-item-label{
      text-align: right;
    }
  }
  @media (max-width: 1199px) {
    .ant-form-item-label{
      text-align: left;
    }
  }

  .ant-calendar .ant-calendar-ok-btn {
    padding-top: 4px;
    color: #fff!Important;
  }

  .ant-calendar-range-picker-input {
    padding-left: 6px;
  }

  #expMM, #expYY {
    @media (max-width: 8000px) {
      display: inline-block;
    }
  }

  // .ag-body .ag-body-viewport .ag-body-container [colid='amountTransactions'] {
  //   display: -webkit-box;
  //   text-align: -webkit-center;
  // }

  [disabled], .ant-btn[disabled], .ant-switch[disabled] {
    cursor: default;
  }
  .ant-switch-disabled * {
    cursor: default;
  }
  .ant-switch-disabled::after {
    cursor: default;
  }

  .charge-exp {
    width: 35px;
  }
  .charge-exp .ant-input-number-handler-wrap {
    display: none;
  }
  .logs-advanced .ant-collapse-item:nth-of-type(odd) {
    background-color: rgba(0,0,0,.03);
  }
  .logs-advanced .ant-collapse-item:nth-of-type(even) {
    background-color: #fff;
  }
  .json-key    { color: black; }
  .json-value  { color: navy; }
  .json-string { color: green; }
  .time {
    vertical-align: sub;
  }
  .time a {
    margin: 5px;
  }

  .ant-form-item-required::before {
    content: ':' !important;
    float: right;
    color: rgba(0, 0, 0, 0.85);
    margin: 0 8px 0 2px !important;
    font-size: 12px !important;
    font-family: Open Sans,Georgia,Times,'Times New Roman',serif !important;
    line-height: 1.5em !important;
    top: 0 !important;
  }
  .ant-form-item-required::after {
    display: inline-block !important;
    content: '*' !important;
    font-family: SimSun !important;
    font-size: 12px !important;
    float: right;
    color: red;
    margin: 0 !important;
    padding: 0 2px 0 2px;
  }

  .btn-social {
    display: block !important;
    margin: 5px 0;
    position: relative;
    padding: 6px 12px 6px 42px !important;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 180px;
  }

  .btn-google {
    color: #fff;
    background-color: #dd4b39;
    border-color: rgba(0,0,0,0.2);
  }

  .btn-linkedin {
    color: #fff;
    background-color: #007bb6;
    border-color: rgba(0,0,0,0.2);
  }

  .btn-linkedin:hover {
    color: #fff;
    background-color: #005983;
    border-color: rgba(0,0,0,0.2);
  }

  .btn-google:hover{
    color:#fff;
    background-color:#c23321;
    border-color:rgba(0,0,0,0.2)
  }

  .btn-social>:first-child {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 32px;
    line-height: 30px;
    font-size: 1.6em;
    text-align: center;
    border-right: 1px solid rgba(0,0,0,0.2);
  }

  .custom-tooltip .ant-tooltip-inner {
    max-width: 600px;
    padding: 8px 10px;
    color: rgba(0, 0, 0, 0.65);
    text-align: left;
    text-decoration: none;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    min-height: 34px;
  }
  .custom-tooltip .ant-tooltip-arrow {
    border-top-color: #fff;
    border-bottom-color: #fff;
  }
  .test-mode-tooltip .ant-tooltip-arrow::before {
    background-color: #fff;
  }
  .custom-switch {
    height: 24px;
    border-width: 2px;
  }
  .custom-switch:after {
    height: 20px;
    width: 20px;
    top: 0;
    margin-left: 0;
  }
  .custom-switch:not(.ant-switch-checked):after {
    left: 0;
  }
  .custom-switch.ant-switch-disabled,
  .custom-switch.ant-switch-disabled:after {
    cursor: pointer;
  }
  .test-mode-note {
    width: 450px;
  }
  .test-mode-note-app {
    width: 450px;
    left: 600px !important;
    top: 74px !important;
  }
  .test-mode-note-sm {
    width: 375px;
    left: 0px !important;
    top: 44px !important;
  }
  .test-mode-note-app.custom-tooltip .ant-tooltip-inner,
  .test-mode-note.custom-tooltip .ant-tooltip-inner {
    width: 450px;
  }
  .test-mode-note-app .ant-tooltip-arrow,
  .test-mode-note .ant-tooltip-arrow,
  .test-mode-note-lg .ant-tooltip-arrow,
  .test-mode-note-sm .ant-tooltip-arrow {
    display: none;
  }

  .ant-pagination-disabled:hover,
  .ant-pagination-disabled:focus,
  .ant-pagination-disabled,
  .ant-pagination-disabled a,
  .ant-select-disabled > div.ant-select-selection,
  .ant-btn.disabled, .ant-btn[disabled] {
    cursor: not-allowed!Important;
  }

  .positive-amount {
    padding-left: 8px!Important;
  }

  // .ag-floating-bottom-container {
  //   .positive-amount {
  //     padding-left: 0px!Important;
  //   }
  // }

  .negative-amount {
    padding-left: 3px!Important;
  }

  .merchant-app-form .ant-form-item-label {
    line-height: 32px !important;
  }
  .merchant-app-form .ant-collapse-content {
    overflow: visible;
    color: rgba(0, 0, 0, 0.65);
    padding: 0 16px;
    background-color: #fff;
    border-top: 1px solid #d9d9d9;
  }
  .merchant-app-form .ant-form-item {
    margin-bottom: 0px
  }
  .merchant-app-form .ant-input-group-addon {
    width: 34px;
    font-size: 15px;
  }
  .merchant-app-form .section-describe {
    color:  #828280;
    margin: 0px 0px 20px 0px;
    display: block;
  }
  .google-autocomplete-container {
    border: 1px solid #d9d9d9;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 2000;
    width: 100%;
    overflow: visible;
  }
  .merchant-app-form .ant-form-item-required::after {
    display: none !important;
  }
  .addon-after .has-success.has-feedback:after {
    margin-right: 32px;
  }
  .addon-after .has-error.has-feedback:after {
    margin-right: 32px;
  }
  .merchant-app-form .ant-form-item-required::before {
    content: '' !important;
  }
  .merchant-app-form .has-error .ant-form-explain,
  .merchant-app-form .has-error .ant-form-split {
    white-space:nowrap;
    text-overflow:ellipsis;
  }
  #activate-your-account span {
    font-weight: bold;
  }
  #complete-merchant-app span {
    font-weight: bold;
  }
  .on-click-link {
    color: #0275d8 !important;
  }
  .on-click-link:hover {
    text-decoration: underline !important;
  }
  .vterminal-modal {
    .vterminal-modal-footer {
      position: absolute;
      bottom: -60px;
      right: 70px;
    }
    .vterminal-modal-footer a:hover,
    .vterminal-transaction-details-button a:hover {
      text-decoration: none;
    }
    .ant-btn-primary {
      border-color: unset;
    }
    .ant-modal-confirm-btns {
      margin-top: 15px;
    }
    .ant-modal-confirm-content {
      position: relative;
    }
  }
  .capitalize-li li,
  .capitalize-li div{
    text-transform: capitalize;
  }
  .dataTable-control {
    min-height: 566px;
  }
  .dataTable-control-margin-top-offset {
    margin-top: -15px;
  }
  .ag-bl-overlay {
    position: relative !important;
    height: 60px !important;
    width: 100% !important;
  }
  .ag-header-cell:not(:last-child)::after {
    border-right: 0.4mm solid #bdc3c7;
    box-sizing: border-box;
    content: " ";
    height: 20px;
    margin-top: 9px;
    position: absolute;
    right: 0;
    text-indent: -2000px;
    top: 0;
  }
  .auth-select-all>span {
    width: 30px;
    margin: 7px auto;
  }
  .smart-select-all>div.ag-react-container {
    margin-top: 10px;
  }
  .ag-overlay-no-rows-wrapper {
    display: none !important;
  }

  .ant-divider{
    font-family:"Chinese Quote",-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB",
    "Microsoft YaHei","Helvetica Neue",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji",
    "Segoe UI Symbol";
    font-size:14px;
    font-variant:tabular-nums;
    line-height:1.5;
    color:rgba(0,0,0,0.65);
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
    margin:0;
    padding:0;
    list-style:none;
    background:#e8e8e8
  }
  .ant-divider,
  .ant-divider-vertical{
    margin:0 8px;
    display:inline-block;
    height:.9em;width:1px;
    vertical-align:middle;
    position:relative;
    top:-0.06em
  }
  .ant-divider-horizontal{
    display:block;
    height:1px;
    width:100%;
    min-width:100%;
    margin:24px 0;
    clear:both
  }
  .ant-divider-horizontal.ant-divider-with-text,.ant-divider-horizontal.ant-divider-with-text-left,
  .ant-divider-horizontal.ant-divider-with-text-right{
    display:table;
    white-space:nowrap;
    text-align:center;
    background:transparent;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    font-size:16px;margin:16px 0
  }
  .ant-divider-horizontal.ant-divider-with-text:before,.ant-divider-horizontal.ant-divider-with-text-left:before,
  .ant-divider-horizontal.ant-divider-with-text-right:before,.ant-divider-horizontal.ant-divider-with-text:after,
  .ant-divider-horizontal.ant-divider-with-text-left:after,
  .ant-divider-horizontal.ant-divider-with-text-right:after{
    content:'';
    display:table-cell;
    position:relative;
    top:50%;
    width:50%;
    border-top:1px solid #e8e8e8;
    -webkit-transform:translateY(50%);
    -ms-transform:translateY(50%);
    transform:translateY(50%)
  }
  .ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text,
  .ant-divider-horizontal.ant-divider-with-text-right .ant-divider-inner-text{
    display:inline-block;
    padding:0 10px
  }
  .ant-divider-horizontal.ant-divider-with-text-left:before{
    top:50%;width:5%
  }
  .ant-divider-horizontal.ant-divider-with-text-left:after{
    top:50%;width:95%
  }
  .ant-divider-horizontal.ant-divider-with-text-right:before{
    top:50%;width:95%
  }
  .ant-divider-horizontal.ant-divider-with-text-right:after{
    top:50%;width:5%
  }
  .ant-divider-inner-text{display:inline-block;padding:0 24px}
  .ant-divider-dashed{background:none;border-top:1px dashed #e8e8e8}
  .ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed,
  .ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed,
  .ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed{border-top:0}
  .ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:before,
  .ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed:before,
  .ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed:before,
  .ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:after,
  .ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed:after,
  .ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed:after{border-style:dashed none none}

  .ant-upload-list-item-name {
    text-align: left;
  }
  .checkout-form .ant-table-placeholder {
    border-bottom: 0px;
  }
  .checkout-meta {
    margin-top: -9px;
  }
  .checkout-form .editable-add-btn {
    position: relative;
    z-index: 10;
    text-align: right !important;
  }
  // .switch-eye-icons {
  //   font-size: 25px;
  //   outline: none;
  //   float: left;
  //   margin: 0 -5px 0 10px;
  // }
  .checkout-form .text-option {
    font-weight: bold;
    color: ${colors.blue};
  }
  .float-none label {
    float: none;
  }
  .checkbox-payment-types {
    display: inline-block !important;
    top: -8px;
  }
  .ant-input-affix-wrapper, .ant-form, .ant-input {
    font-size: 13px;
  }
  .ant-form-item {
    margin-bottom: 20px;
  }
  .has-success.has-feedback .ant-form-item-children-icon {
    color: #00a854;
  }
  .ant-menu:not(.ant-menu-horizontal):not(.ant-menu-dark) .ant-menu-item-selected {
    background: #f3f4f6;
  }
  .ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: #111827!important;
  }
  .ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected a {
    color: #ffffff;
  }
  .ant-menu-dark .ant-menu-item:hover, .ant-menu-dark .ant-menu-item:hover, .ant-menu-dark .ant-menu-item-active,
  .ant-menu-dark .ant-menu-submenu-title:hover {
    background: #374151;
  }
  .ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: #1F2937;
    box-shadow: none;
  }
  .ant-menu-inline .ant-menu-selected::after, .ant-menu-inline .ant-menu-item-selected::after {
    display: none;
  }
  .ant-menu-item:active, .ant-menu-submenu-title:active, .ant-menu-item:hover, .ant-menu-submenu-title:hover {
    background: #f9fafb;
  }
  .ant-menu, .ant-menu * {
    transition: none!important;
  }
  .ant-menu svg {
    fill: transparent;
    margin-right: 12px;
  }
  .ant-menu-item a span, .ant-menu-submenu-title span {
    display: flex;
    align-items: center;
  }
  .ant-menu .ant-menu-sub.ant-menu-inline {
    padding: 0;
  }
  .ant-menu .ant-menu-sub.ant-menu-inline .ant-menu-item {
    padding-left: 44px!important;
  }
  .ant-menu .icon {
    color: #9CA3AF;
  }
  .ant-menu .ant-menu-item-selected .icon {
    color: #6b7280;
  }
  .ant-menu-dark .ant-menu-item-selected .icon {
    color: #E5E7EB;
  }
  .ant-menu .separator + .separator, .ant-menu > *:last-child:not(.ant-menu-item) {
    display: none;
  }
  .ant-menu a:hover, .ant-menu a:focus,
  .ant-menu-item-selected > a, .ant-menu-item-selected > a:hover,
  .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-submenu-active, .ant-menu-submenu-title:hover, .ant-menu-item > a:hover,
  .ant-menu-submenu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover, .ant-menu-submenu-selected {
    color: #111827;
  }
  .ant-menu-vertical .ant-menu-item, .ant-menu-vertical-left .ant-menu-item, .ant-menu-vertical-right .ant-menu-item,
  .ant-menu-inline .ant-menu-item, .ant-menu-vertical .ant-menu-submenu-title,
  .ant-menu-vertical-left .ant-menu-submenu-title, .ant-menu-vertical-right .ant-menu-submenu-title,
  .ant-menu-inline .ant-menu-submenu-title {
    font-size: 14px;
    border-radius: 6px;
    transition: none;
  }
  .ant-menu-vertical .ant-menu-submenu, .ant-menu-vertical-left .ant-menu-submenu,
  .ant-menu-vertical-right .ant-menu-submenu, .ant-menu-inline .ant-menu-submenu {
    padding-bottom: 0px;
  }
  .ant-input {
    font-size: 12px;
    height: 32px;
  }
  .ant-menu-dark, .ant-menu-dark .ant-menu-sub,
  .ant-menu-dark .ant-menu-item, .ant-menu-dark .ant-menu-item-group-title, .ant-menu-dark .ant-menu-item > a {
    color: #d1d5db;
  }
  .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
  .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
  .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
  .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
  .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
  .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
  .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
  .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
    width: 5px;
    height: 1.5px;
    background: #656b79!important;
  }
  .ant-menu-dark .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
  .ant-menu-dark .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
    background: #fff!important;
  }
  .ant-breadcrumb{
    line-height: inherit;
    font-size: 12px;
  }
  .ant-menu-vertical .ant-menu-item, .ant-menu-vertical-left .ant-menu-item, .ant-menu-vertical-right .ant-menu-item,
  .ant-menu-inline .ant-menu-item, .ant-menu-vertical .ant-menu-submenu-title,
  .ant-menu-vertical-left .ant-menu-submenu-title, .ant-menu-vertical-right .ant-menu-submenu-title,
  .ant-menu-inline .ant-menu-submenu-title {
    margin: 0px;
    padding-left: 8px!important;
  }
  .ant-menu-vertical .ant-menu-item:not(:last-child), .ant-menu-vertical-left .ant-menu-item:not(:last-child),
  .ant-menu-vertical-right .ant-menu-item:not(:last-child), .ant-menu-inline .ant-menu-item:not(:last-child) {
    margin-bottom: 4px;
  }
  .ant-menu-vertical > .ant-menu-item, .ant-menu-vertical-left > .ant-menu-item,
  .ant-menu-vertical-right > .ant-menu-item, .ant-menu-inline > .ant-menu-item,
  .ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    height: 40px;
    line-height: 40px;
  }
  .anticon svg {
    display: block;
  }
  .ant-select-selection--multiple {
    .ant-select-selection__choice__remove svg {
      display: block;
    }
  }
  .ant-tag-blue {
    color: inherit;
    background: inherit;
    border-color: #d9d9d9;
    cursor: pointer;
  }
  .ant-pagination {
    font-size: 12px;
    color: #292b2c;
  }
  .ant-pagination-item-active {
    color: #1890ff;
  }
  .ant-pagination-next,
  .ant-pagination-prev,
  .ant-pagination-item {
    min-width: 28px;
    display: inline-block;
    vertical-align: middle;
    height: 28px;
    line-height: 28px;
  }
  .pagination-item:hover {
    border-color: #1890ff;
  }
  .ant-pagination-item:hover {
    color: #1890ff;
  }
  .ant-table,
  .ant-popover,
  .ant-checkbox-wrapper,
  .ant-dropdown-menu-submenu-title,
  .ant-form-item, .ant-form label
  .ant-select-dropdown,
  .ant-select {
    font-size: 12px;
  }
  .ant-select-selection--single {
    height: 28px;
  }
  .ant-pagination-prev .ant-pagination-item-link, .ant-pagination-next .ant-pagination-item-link,
  .ant-select-arrow {
    font-size: 10px;
  }
  .ant-pagination .anticon {
    vertical-align: baseline;
  }
  .ant-select-selection__rendered {
    line-height: 28px;
  }
  .ant-form-item-control {
    line-height: 32px;
  }
  .ant-btn {
    font-size: 12px;
  }
  .ant-dropdown-menu-item-disabled,
  .ant-dropdown-menu-item-disabled:hover {
    cursor: default;
  }
  .app-main-content-Dashboard {
    padding: 0 !important;
  }
  .select-add-new svg { // invoice-edit-page
    margin-top: -6px;
  }
  .custom-tree-select {
    .ant-select-selection__rendered {
      margin-left: 0 !important;
    }
  }
  .custom-tree-dropdown-select {
    .ant-select-tree {
      margin-top: 0;
      padding: 0;
    }

    .ant-select-tree li,
    .ant-select-tree-node-content-wrapper {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }

    .ant-select-tree-switcher {
      display: none !important;
    }

    .ant-select-dropdown-search {
      padding: 0;
    }

    .ant-select-search__field {
      border: 0 !important;
      border-bottom: 1px solid #d9d9d9 !important;
      border-radius: 0 !important;
      height: 32px;
    }
  }
  .ant-dropdown-menu-item {
      font-size: 14px;

      &:hover {
        background-color: #f5f5f5;
      }
  }
  .ant-back-top {
    bottom: 75px;
  }
  .noscroll {
    overflow: hidden;
  }

  .ant-calendar-range-picker-input {
    line-height: 1;
  }

  .main-content-wrapper {
    background: #fff;
    padding: 7px 14px 14px;
    box-shadow: 4px 4px 20px 0 rgba(0,0,0,.01);
    min-height: calc(100vh - 184px);
  }
`;
